:host {
  display: block;
}

.spw-custom-select {
  position: relative;
  &__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 0 12px;
    line-height: 40px;
    border-radius: 4px;
    border: 1px solid var(--spw-color-themes-grey-grey-800);
    background-color: #fff;
    &:hover {
      outline: 4px solid var(--spw-color-themes-grey-grey-300);
    }
    &:focus-within,
    &:focus-visible {
      outline: 3px solid var(--spw-ds-focus);
      outline-offset: 2px;
    }
    .spw-custom-select--disabled & {
      border-color: var(--spw-color-themes-grey-grey-400);
      background: var(--spw-color-themes-grey-grey-100);
      color: var(--spw-color-themes-grey-grey-500);
      cursor: not-allowed;
      &::placeholder {
        color: var(--spw-color-themes-grey-grey-500);
      }
      &:hover,
      &:focus,
      &:focus-visible {
        outline: none;
      }
    }
    .spw-custom-select--is-error & {
      border-color: var(--spw-colors-states-error-error-300);
    }
    .spw-custom-select--large & {
      height: 60px;
      padding: 0 24px;
      line-height: 60px;
    }
    .spw-custom-select--is-opened & {
      height: auto;
      line-height: 1;
      min-height: 40px;
      border-radius: 4px 4px 0 0;
      border-bottom-color: transparent;
    }
  }

  &__selected {
    flex: 1;
    padding-right: 30px;
    max-width: 100%;
  }

  &__selected-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--spw-color-themes-grey-grey-900);
    border: 1px solid var(--spw-color-themes-grey-grey-900);
    background: var(--spw-color-themes-grey-grey-200);
    line-height: 24px;
    height: 24px;
    padding: 0 8px;
    margin: 4px 6px 2px 0;
    border-radius: 999px;
    font-size: 14px;
    user-select: none;
  }

  &__selected-items {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    .spw-custom-select--is-opened & {
      padding-top: 3px;
      padding-bottom: 4px;
      overflow: visible;
      text-overflow: initial;
      text-wrap: initial;
    }
  }

  &__arrow {
    position: absolute;
    right: 12px;
    top: 14px;
    font-size: 12px;
    color: var(--spw-color-themes-grey-grey-600);
    pointer-events: none;
  }

  &__wrapper {
    position: relative;
  }

  &__search {
    .spw-custom-select--is-opened & {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 11;
      width: 100%;
      margin-top: 1px;
    }
    .spw-custom-select--has-value.spw-custom-select--is-opened & {
      top: auto;
      top: 100%;
      margin-top: -3px;
    }
    &-input {
      padding: 0;
      height: 38px;
      line-height: 40px;
      border: none;
      margin: 0;
      width: calc(100% - 30px);
      text-overflow: ellipsis;
      &:focus {
        outline: none;
      }
      .spw-custom-select--is-opened & {
        border-left: 1px solid var(--spw-color-themes-grey-grey-800);
        padding: 0 12px;
      }
      .spw-custom-select--is-opened.spw-custom-select--has-value & {
        border-right: 1px solid var(--spw-color-themes-grey-grey-800);
        width: 100%;
      }
    }
  }

  &__options {
    position: absolute;
    width: 100%;
    background-color: #fff;
    border: 1px solid var(--spw-color-themes-grey-grey-800);
    border-radius: 0 0 4px 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 12;

    &--down {
      top: 100%;
      transform: translateY(0);
    }

    &--up {
      top: 100%;
      transform: translateY(0);
    }

    .spw-custom-select--has-value.spw-custom-select--is-opened:not(.spw-custom-select--not-searchable) & {
      margin-top: 35px;
    }
  }

  &__no-results {
    padding: 12px;
    cursor: not-allowed;
    color: var(--spw-color-themes-grey-grey-600);
  }

  &__option {
    border-bottom: 1px solid var(--spw-color-themes-grey-grey-900);
    padding: 12px;
    cursor: pointer;
    &:hover {
      background-color: var(--spw-color-themes-grey-grey-200);
    }
    &:last-child {
      border-bottom: none;
    }
    &--selected {
      font-weight: 700;
    }
  }

  &__error {
    display: block;
    font-size: 12px;
    color: var(--spw-color-themes-grey-grey-600);
    margin-top: 8px;
  }
}

.spw-custom-select__option--focused {
  background-color: var(--spw-color-themes-grey-grey-300);
}
